import { Box, Stack } from '@mui/system'
import React from 'react'
import Navbar from '../Navbar'
import { Typography, Button, Grid, IconButton, List, ListItem, ListItemIcon, ListItemText } from '@mui/material'
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import jobImage from '../../images/jobImage.svg'
import jobLogoImage from '../../images/logoJobImage.svg'
import BookmarkBorderIcon from '@mui/icons-material/BookmarkBorder';
import { object } from 'prop-types';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import BusinessIcon from '@mui/icons-material/Business';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import FolderOpenOutlinedIcon from '@mui/icons-material/FolderOpenOutlined';
import BusinessCenterOutlinedIcon from '@mui/icons-material/BusinessCenterOutlined';
import LocalPhoneOutlinedIcon from '@mui/icons-material/LocalPhoneOutlined';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import AccessibilityNewOutlinedIcon from '@mui/icons-material/AccessibilityNewOutlined';
import SupervisedUserCircleOutlinedIcon from '@mui/icons-material/SupervisedUserCircleOutlined';
import facebookIcon from '../../images/facebookIcon.svg'
import twitterIcon from '../../images/twitterIcon.svg'
import linkedinIcon from '../../images/linkedinIcon.svg'
import instagramIcon from '../../images/instagramIcon.svg'
import linkIcon from '../../images/linkIcon.svg'
import { useNavigate } from 'react-router-dom';
import Layout from '../../assets/Layout';
export default function JobPreview() {

    const navigate = useNavigate();
    return (
        <>
            <Layout>

                <Box mt={10} >
                    <Button
                        className='text2Mid'
                        sx={{
                            py: 1,
                            px: 3,
                            mx: {md:10, xs:1},
                            backgroundColor: '#F7FAFF',
                            borderRadius: '0.5rem',
                            color: '#2544EE',
                            border: '1px solid #2544EE',
                            '&:hover': {
                                color: '#fff',
                                backgroundColor: '#2544EE'
                            },
                        }}
                        startIcon={<ArrowBackIosIcon />}
                        onClick={() => navigate('/employer/job-post')}
                        variant="contained">
                        Go Back
                    </Button>
                    <Typography
                        variant="h4"
                        align="center"
                        sx={{ display: 'inline', ml:{md:"25%", xs:"10%"} }}
                    >
                        Job Preview
                    </Typography>
                </Box>

                <Box mx={{md:10, xs:1}} my={3}>
                    <Typography
                        variant="h6"
                        className='subHeading2Bold'
                    >
                        Senior Rolling Stock Technicion
                    </Typography>

                    <Grid container >
                        <Grid item md={8} sx={{ maxWidth: '100%' }}>
                            <div style={{ position: 'relative' }}>
                                <img src={jobImage} alt='Job Image' width={'100%'} style={{ borderRadius: '10px' }} />
                                <IconButton
                                    style={{ position: 'absolute', top: '10px', right: '10px', backgroundColor: '#fff' }}
                                    color="primary"
                                    aria-label="Bookmark"
                                >
                                    <BookmarkBorderIcon sx={{ color: '#000' }} />
                                </IconButton>
                                <Box
                                    sx={{
                                        position: 'absolute',
                                        bottom: '10px',
                                        left: '10px',
                                        height: { xs: '4rem', sm: '5rem' },
                                        width: { xs: '4rem', sm: '5rem' },
                                        borderRadius: '10px',
                                        overflow: 'hidden',
                                    }}
                                >
                                    <img src={jobLogoImage} alt='Job Image' width={'100%'} height={'100%'} style={{ objectFit: 'cover' }} />
                                </Box>
                            </div>

                            <Stack mt={2}>
                                <Typography variant="h6" className='text1Bold'>
                                    Baldota Group
                                </Typography>

                                <Typography variant="h6" className='text1Mid'>
                                    136 Sunset Blvd Los angles, Ca 900026, USA
                                </Typography>

                                <Typography variant="h6" className='text1Bold' sx={{ color: '#2544EE' }}>
                                    https://thewebmax.com
                                </Typography>

                                <Typography mt={4} variant="h6" className='text1Bold'>
                                    Job Description:
                                </Typography>
                                <Typography sx={{ textAlign: 'justify' }} variant="body2" className='text2Mid'>
                                    Lorem ipsum dolor sit amet consectetur. Turpis in sapien in a nunc nibh volutpat. Massa mattis molestie amet dui volutpat.
                                    Tellus lacinia pulvinar pharetra viverra morbi tincidunt mi mus.
                                    Lobortis maecenas pulvinar pretium est morbi ut diam pulvinar.
                                    Pellentesque id lacus id elit leo cursus purus tempus tortor. Amet ultricies proin egestas egestas pellentesque adipiscing euismod sit imperdiet.

                                    Lorem ipsum dolor sit amet consectetur. Turpis in sapien in a nunc nibh volutpat. Massa mattis molestie amet dui volutpat.
                                    Tellus lacinia pulvinar pharetra viverra morbi tincidunt mi mus.
                                    Lobortis maecenas pulvinar pretium est morbi ut diam pulvinar.
                                    Pellentesque id lacus id elit leo cursus purus tempus tortor. Amet ultricies proin egestas egestas pellentesque adipiscing euismod sit imperdiet.
                                </Typography>
                            </Stack>

                            <Box>
                                <Typography mt={4} variant="h6" className='text1Bold'>
                                    Requirements
                                </Typography>
                                <List>
                                    <ListItem disablePadding mt={1}>
                                        <CheckCircleIcon sx={{ color: '#2544EE', fontSize: '18px' }} />
                                        <Typography variant="body2" className='text2Mid' mx={2} sx={{ lineHeight: '1rem' }}>
                                            Must be able to communicate with others to convery information effectively.
                                        </Typography>
                                    </ListItem>

                                    <ListItem disablePadding sx={{ mt: 1 }}>
                                        <CheckCircleIcon sx={{ color: '#2544EE', fontSize: '18px' }} />
                                        <Typography variant="body2" className='text2Mid' mx={2} sx={{ lineHeight: '1rem' }}>
                                            Personally passionate and up to date with current trends and technology, committied to quality and comfortable working with adult media.
                                        </Typography>
                                    </ListItem>

                                    <ListItem disablePadding sx={{ mt: 1 }}>
                                        <CheckCircleIcon sx={{ color: '#2544EE', fontSize: '18px' }} />
                                        <Typography variant="body2" className='text2Mid' mx={2} sx={{ lineHeight: '1rem' }}>
                                            Bachelor or Master degree level educational background.
                                        </Typography>
                                    </ListItem>
                                </List>
                            </Box>

                            <Box>
                                <Typography mt={4} variant="h6" className='text1Bold'>
                                    Responsibilities:
                                </Typography>
                                <List>
                                    <ListItem disablePadding mt={1}>
                                        <CheckCircleIcon sx={{ color: '#2544EE', fontSize: '18px' }} />
                                        <Typography variant="body2" className='text2Mid' mx={2} sx={{ lineHeight: '1rem' }}>
                                            Must be able to communicate with others to convery information effectively.
                                        </Typography>
                                    </ListItem>

                                    <ListItem disablePadding sx={{ mt: 1 }}>
                                        <CheckCircleIcon sx={{ color: '#2544EE', fontSize: '18px' }} />
                                        <Typography variant="body2" className='text2Mid' mx={2} sx={{ lineHeight: '1rem' }}>
                                            Personally passionate and up to date with current trends and technology, committied to quality and comfortable working with adult media.
                                        </Typography>
                                    </ListItem>

                                    <ListItem disablePadding sx={{ mt: 1 }}>
                                        <CheckCircleIcon sx={{ color: '#2544EE', fontSize: '18px' }} />
                                        <Typography variant="body2" className='text2Mid' mx={2} sx={{ lineHeight: '1rem' }}>
                                            Bachelor or Master degree level educational background.
                                        </Typography>
                                    </ListItem>
                                </List>
                            </Box>

                            <Box>
                                <Typography mt={4} variant="h6" className='text1Bold'>
                                    Additional Benefits
                                </Typography>
                                <List>
                                    <ListItem disablePadding mt={1}>
                                        <CheckCircleIcon sx={{ color: '#2544EE', fontSize: '18px' }} />
                                        <Typography variant="body2" className='text2Mid' mx={2} sx={{ lineHeight: '1rem' }}>
                                            Must be able to communicate with others to convery information effectively.
                                        </Typography>
                                    </ListItem>

                                    <ListItem disablePadding sx={{ mt: 1 }}>
                                        <CheckCircleIcon sx={{ color: '#2544EE', fontSize: '18px' }} />
                                        <Typography variant="body2" className='text2Mid' mx={2} sx={{ lineHeight: '1rem' }}>
                                            Personally passionate and up to date with current trends and technology, committied to quality and comfortable working with adult media.
                                        </Typography>
                                    </ListItem>

                                    <ListItem disablePadding sx={{ mt: 1 }}>
                                        <CheckCircleIcon sx={{ color: '#2544EE', fontSize: '18px' }} />
                                        <Typography variant="body2" className='text2Mid' mx={2} sx={{ lineHeight: '1rem' }}>
                                            Bachelor or Master degree level educational background.
                                        </Typography>
                                    </ListItem>
                                </List>
                            </Box>
                        </Grid>

                        <Grid item xs={12} md={3} mx={2} px={2} py={2} sx={{ background: 'linear-gradient(to left, #F2F4FB, #C8D8F1)', height: '100%', borderRadius: '10px' }}>
                            <Typography
                                variant="body"
                                className='text1Bold'
                            >
                                Job Information
                            </Typography>

                            <Box sx={{ backgroundColor: '#fff', borderRadius: '4px', p: 1 }}>
                                <CalendarTodayIcon sx={{ color: '#2544EE', mx: 1 }} />
                                <Typography
                                    variant="caption"
                                    className='text2Mid'
                                >
                                    Expires on 20 October 2022
                                </Typography>
                            </Box>

                            <Box sx={{ p: 1, my: 1 }}>
                                <Grid container>
                                    <Grid item md={2}>
                                        <CalendarMonthIcon sx={{ color: '#2544EE', mx: 1, fontSize: '36px' }} />
                                    </Grid>
                                    <Grid item md={1}></Grid>
                                    <Grid item md={8}>
                                        <div style={{ display: 'flex', flexDirection: 'column' }}>
                                            <Typography variant="caption" sx="font-size: 8px;">
                                                Date Posted
                                            </Typography>
                                            <Typography variant="caption" sx={{ fontSize: '12px', fontWeight: 'bold' }}>
                                                April 22, 2023
                                            </Typography>
                                        </div>
                                    </Grid>
                                </Grid>
                            </Box>

                            <Box sx={{ p: 1, my: 1 }}>
                                <Grid container>
                                    <Grid item md={2}>
                                        <BusinessIcon sx={{ color: '#2544EE', mx: 1, fontSize: '36px' }} />
                                    </Grid>
                                    <Grid item md={1}></Grid>
                                    <Grid item md={8}>
                                        <div style={{ display: 'flex', flexDirection: 'column' }}>
                                            <Typography variant="caption" sx="font-size: 8px;">
                                                Industry:
                                            </Typography>
                                            <Typography variant="caption" sx={{ fontSize: '12px', fontWeight: 'bold' }}>
                                                IT & Sofware
                                            </Typography>
                                        </div>
                                    </Grid>
                                </Grid>
                            </Box>

                            <Box sx={{ p: 1, my: 1 }}>
                                <Grid container>
                                    <Grid item md={2}>
                                        <LocationOnIcon sx={{ color: '#2544EE', mx: 1, fontSize: '36px' }} />
                                    </Grid>
                                    <Grid item md={1}></Grid>
                                    <Grid item md={8}>
                                        <div style={{ display: 'flex', flexDirection: 'column' }}>
                                            <Typography variant="caption" sx="font-size: 8px;">
                                                Location
                                            </Typography>
                                            <Typography variant="caption" sx={{ fontSize: '12px', fontWeight: 'bold' }}>
                                                Gurugram,Haryana
                                            </Typography>
                                        </div>
                                    </Grid>
                                </Grid>
                            </Box>

                            <Box sx={{ p: 1, my: 1 }}>
                                <Grid container>
                                    <Grid item md={2}>
                                        <FolderOpenOutlinedIcon sx={{ color: '#2544EE', mx: 1, fontSize: '36px' }} />
                                    </Grid>
                                    <Grid item md={1}></Grid>
                                    <Grid item md={8}>
                                        <div style={{ display: 'flex', flexDirection: 'column' }}>
                                            <Typography variant="caption" sx="font-size: 8px;">
                                                Job Title
                                            </Typography>
                                            <Typography variant="caption" sx={{ fontSize: '12px', fontWeight: 'bold' }}>
                                                Web Developer
                                            </Typography>
                                        </div>
                                    </Grid>
                                </Grid>
                            </Box>

                            <Box sx={{ p: 1, my: 1 }}>
                                <Grid container>
                                    <Grid item md={2}>
                                        <BusinessCenterOutlinedIcon sx={{ color: '#2544EE', mx: 1, fontSize: '36px' }} />
                                    </Grid>
                                    <Grid item md={1}></Grid>
                                    <Grid item md={8}>
                                        <div style={{ display: 'flex', flexDirection: 'column' }}>
                                            <Typography variant="caption" sx="font-size: 8px;">
                                                Experience
                                            </Typography>
                                            <Typography variant="caption" sx={{ fontSize: '12px', fontWeight: 'bold' }}>
                                                3-4 Years
                                            </Typography>
                                        </div>
                                    </Grid>
                                </Grid>
                            </Box>

                            <Box sx={{ p: 1, my: 1 }}>
                                <Grid container>
                                    <Grid item md={2}>
                                        <LocalPhoneOutlinedIcon sx={{ color: '#2544EE', mx: 1, fontSize: '36px' }} />
                                    </Grid>
                                    <Grid item md={1}></Grid>
                                    <Grid item md={8}>
                                        <div style={{ display: 'flex', flexDirection: 'column' }}>
                                            <Typography variant="caption" sx="font-size: 8px;">
                                                Phone Number
                                            </Typography>
                                            <Typography variant="caption" sx={{ fontSize: '12px', fontWeight: 'bold' }}>
                                                +91- XXXXXX9876
                                            </Typography>
                                        </div>
                                    </Grid>
                                </Grid>
                            </Box>

                            <Box sx={{ p: 1, my: 1 }}>
                                <Grid container>
                                    <Grid item md={2}>
                                        <EmailOutlinedIcon sx={{ color: '#2544EE', mx: 1, fontSize: '36px' }} />
                                    </Grid>
                                    <Grid item md={1}></Grid>
                                    <Grid item md={8}>
                                        <div style={{ display: 'flex', flexDirection: 'column' }}>
                                            <Typography variant="caption" sx="font-size: 8px;">
                                                Email Address
                                            </Typography>
                                            <Typography variant="caption" sx={{ fontSize: '12px', fontWeight: 'bold' }}>
                                                AcXXXX@gmail.com
                                            </Typography>
                                        </div>
                                    </Grid>
                                </Grid>
                            </Box>

                            <Box sx={{ p: 1, my: 1 }}>
                                <Grid container>
                                    <Grid item md={2}>
                                        <AccessibilityNewOutlinedIcon sx={{ color: '#2544EE', mx: 1, fontSize: '36px' }} />
                                    </Grid>
                                    <Grid item md={1}></Grid>
                                    <Grid item md={8}>
                                        <div style={{ display: 'flex', flexDirection: 'column' }}>
                                            <Typography variant="caption" sx="font-size: 8px;">
                                                Gneder
                                            </Typography>
                                            <Typography variant="caption" sx={{ fontSize: '12px', fontWeight: 'bold' }}>
                                                Male
                                            </Typography>
                                        </div>
                                    </Grid>
                                </Grid>
                            </Box>

                            <Box sx={{ p: 1, my: 1 }}>
                                <Grid container>
                                    <Grid item md={2}>
                                        <SupervisedUserCircleOutlinedIcon sx={{ color: '#2544EE', mx: 1, fontSize: '36px' }} />
                                    </Grid>
                                    <Grid item md={1}></Grid>
                                    <Grid item md={8}>
                                        <div style={{ display: 'flex', flexDirection: 'column' }}>
                                            <Typography variant="caption" sx="font-size: 8px;">
                                                No. of Openiings
                                            </Typography>
                                            <Typography variant="caption" sx={{ fontSize: '12px', fontWeight: 'bold' }}>
                                                20
                                            </Typography>
                                        </div>
                                    </Grid>
                                </Grid>
                            </Box>

                            <Box sx={{ p: 1, my: 1 }}>
                                <Grid container>
                                    <Grid item md={2}>
                                        <SupervisedUserCircleOutlinedIcon sx={{ color: '#2544EE', mx: 1, fontSize: '36px' }} />
                                    </Grid>
                                    <Grid item md={1}></Grid>
                                    <Grid item md={8}>
                                        <div style={{ display: 'flex', flexDirection: 'column' }}>
                                            <Typography variant="caption" sx="font-size: 8px;">
                                                Offered Salary
                                            </Typography>
                                            <Typography variant="caption" sx={{ fontSize: '12px', fontWeight: 'bold' }}>
                                                40-50K/Month
                                            </Typography>
                                        </div>
                                    </Grid>
                                </Grid>
                            </Box>

                            <Box sx={{ p: 1, my: 1 }}>
                                <Typography variant="body1" className='text1Bold'>
                                    Social Media
                                </Typography>
                                <Grid container>
                                    <Grid item md={2}>
                                        <img src={facebookIcon} alt='Facebook' width={'25px'} />
                                    </Grid>
                                    <Grid item md={2}>
                                        <img src={twitterIcon} alt='Facebook' width={'25px'} />
                                    </Grid>
                                    <Grid item md={2}>
                                        <img src={linkedinIcon} alt='Facebook' width={'25px'} />
                                    </Grid>
                                    <Grid item md={2}>
                                        <img src={instagramIcon} alt='Facebook' width={'25px'} />
                                    </Grid>
                                    <Grid item md={2}>
                                        <img src={linkIcon} alt='Facebook' width={'25px'} />
                                    </Grid>
                                </Grid>
                            </Box>

                            <Box sx={{ p: 1, my: 1 }}>

                                <Typography variant="body1" className='text1Bold'>
                                    Skills
                                </Typography>
                                <Grid container>
                                    <Grid item md={4} my={1}>
                                        <Typography variant="caption" className='text2Mid' sx={{ backgroundColor: '#fff', p: 1, borderRadius: '5px' }}>
                                            HTML
                                        </Typography>
                                    </Grid>
                                    <Grid item md={4} my={1}>
                                        <Typography variant="caption" className='text2Mid' sx={{ backgroundColor: '#fff', p: 1, borderRadius: '5px' }}>
                                            Python
                                        </Typography>
                                    </Grid>
                                    <Grid item md={4} my={1}>
                                        <Typography variant="caption" className='text2Mid' sx={{ backgroundColor: '#fff', p: 1, borderRadius: '5px' }}>
                                            HTML
                                        </Typography>
                                    </Grid>

                                    <Grid item md={4} my={1}>
                                        <Typography variant="caption" className='text2Mid' sx={{ backgroundColor: '#fff', p: 1, borderRadius: '5px' }}>
                                            Wordpress
                                        </Typography>
                                    </Grid>

                                    <Grid item md={4} my={1}>
                                        <Typography variant="caption" className='text2Mid' sx={{ backgroundColor: '#fff', p: 1, borderRadius: '5px' }}>
                                            HTML
                                        </Typography>
                                    </Grid>
                                    <Grid item md={4} my={1}>
                                        <Typography variant="caption" className='text2Mid' sx={{ backgroundColor: '#fff', p: 1, borderRadius: '5px' }}>
                                            Python
                                        </Typography>
                                    </Grid>
                                    <Grid item md={4} my={1}>
                                        <Typography variant="caption" className='text2Mid' sx={{ backgroundColor: '#fff', p: 1, borderRadius: '5px' }}>
                                            HTML
                                        </Typography>
                                    </Grid>

                                    <Grid item md={4} my={1}>
                                        <Typography variant="caption" className='text2Mid' sx={{ backgroundColor: '#fff', p: 1, borderRadius: '5px' }}>
                                            Wordpress
                                        </Typography>
                                    </Grid>


                                </Grid>
                            </Box>

                            <Box sx={{ p: 1, my: 1 }}>

                                <Typography variant="body1" className='text1Bold'>
                                    Keywords
                                </Typography>
                                <Grid container>
                                    <Grid item md={4} my={1}>
                                        <Typography variant="caption" className='text2Mid' sx={{ backgroundColor: '#fff', p: 1, borderRadius: '5px' }}>
                                            HTML
                                        </Typography>
                                    </Grid>
                                    <Grid item md={4} my={1}>
                                        <Typography variant="caption" className='text2Mid' sx={{ backgroundColor: '#fff', p: 1, borderRadius: '5px' }}>
                                            Python
                                        </Typography>
                                    </Grid>
                                    <Grid item md={4} my={1}>
                                        <Typography variant="caption" className='text2Mid' sx={{ backgroundColor: '#fff', p: 1, borderRadius: '5px' }}>
                                            HTML
                                        </Typography>
                                    </Grid>

                                    <Grid item md={4} my={1}>
                                        <Typography variant="caption" className='text2Mid' sx={{ backgroundColor: '#fff', p: 1, borderRadius: '5px' }}>
                                            Wordpress
                                        </Typography>
                                    </Grid>

                                    <Grid item md={4} my={1}>
                                        <Typography variant="caption" className='text2Mid' sx={{ backgroundColor: '#fff', p: 1, borderRadius: '5px' }}>
                                            HTML
                                        </Typography>
                                    </Grid>
                                    <Grid item md={4} my={1}>
                                        <Typography variant="caption" className='text2Mid' sx={{ backgroundColor: '#fff', p: 1, borderRadius: '5px' }}>
                                            Python
                                        </Typography>
                                    </Grid>
                                    <Grid item md={4} my={1}>
                                        <Typography variant="caption" className='text2Mid' sx={{ backgroundColor: '#fff', p: 1, borderRadius: '5px' }}>
                                            HTML
                                        </Typography>
                                    </Grid>

                                    <Grid item md={4} my={1}>
                                        <Typography variant="caption" className='text2Mid' sx={{ backgroundColor: '#fff', p: 1, borderRadius: '5px' }}>
                                            Wordpress
                                        </Typography>
                                    </Grid>


                                </Grid>



                            </Box>

                        </Grid>
                    </Grid >
                </Box >
            </Layout>
        </>
    )
}
